<mat-chip-set role="list">
  
  <mat-chip class="filter-chip" role="listitem" *ngIf="category" (removed)="removeFilter('category')">
    <span class="label">{{category}}</span>
    <button matChipRemove>
      <mat-icon fontSet="material-symbols-outlined" >cancel</mat-icon>
    </button>
  </mat-chip>
</mat-chip-set>